import { css } from '@emotion/css';

export const localeDropdownCss = css`
  .sdsm-dropdown-button {
    font-size: 14px;
    line-height: 20px;
  }
`;
